import TechShipPortalList from './techshipportallistmodel-list-screen.vue';

export default {
    components: {
        'techship_portals_list': TechShipPortalList
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            model: this.emptyModel()
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
                DomainSuffix: "undefined"
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/techship_portals_applications/load/' + this.appId;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.techship_portals_list.channelSettings = {
                    ApplicationId: this.model.AppId,
                    DomainSuffix: this.model.DomainSuffix
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}